export default __webpack_public_path__ + "static/media/A.135a8795.png";